/**
 * GraphQL Query
 * 顧客画面
 */

/**
 * 顧客一覧
 */

export const GRAPH_QL_QUERY_CUSTOMER_LIST =
`
  query {
    customers( ? ) {
      edges {
        node {
          id
          uuid
          customerGroup {
            code
            name
          }
          nos {
            id
            no
            type
            priority
          }
          personalInfo {
            lastName
            secondName
            firstName
            suffix
            lastNameKana
            firstNameKana
            phone
            email
          }
          point
          limitedPoint
          limitedPointExpires
          rank {
            code
            name
            pointCoef
          }
        }
      }
      totalCount
    }
  }
`

/**
 * 顧客詳細
 */
export const GRAPH_QL_QUERY_CUSTOMER_DETAIL =
`
  query {
    customer( ? ) {
      id
      uuid
      customerGroup {
        code
        name
        pointBaseConfig {
          expires
          expiresUnit
          expireRule
        }
      }
      nos {
        id
        no
        type
        priority
      }
      birthday
      registeredAt
      gender
      personalInfo {
        lastName
        secondName
        firstName
        suffix
        lastNameKana
        firstNameKana
        phone
        email
        companyName
        jobTitle
      }
      latestOrders {
        id
        site {
          code
          name
        }
        orderNo
        orderDatetime
        orderer {
          lastName
          secondName
          firstName
          suffix
          lastNameKana
          firstNameKana
          phone
          email
        }
        qty {
          current
          ordered
          unallocated
          pending
          preExport
          preReExport
          canceled
          exported
          shipped
          unshipped
          inshipCanceled
          transfer
          receiveShipped
          receiveFixed
          exOut
          exOutExported
          exOutShipped
          exOutUnshipped
          exOutFixed
          exIn
          exInShipped
          exInFixed
        }
        shipments {
          shipmentId
          items {
            qty {
              current
              ordered
              unallocated
              pending
              preExport
              preReExport
              canceled
              exported
              shipped
              unshipped
              inshipCanceled
              transfer
              receiveShipped
              receiveFixed
              exOut
              exOutExported
              exOutShipped
              exOutUnshipped
              exOutFixed
              exIn
              exInShipped
              exInFixed
            }
            isBundle
            isShipment
            bundleItems {
              isBundle
              isShipment
              qty {
                current
                ordered
                unallocated
                pending
                preExport
                preReExport
                canceled
                exported
                shipped
                unshipped
                inshipCanceled
                transfer
                receiveShipped
                receiveFixed
                exOut
                exOutExported
                exOutShipped
                exOutUnshipped
                exOutFixed
                exIn
                exInShipped
                exInFixed
              }
            }
          }
        }
        payments {
          paymentMethod {
            code
            name
            nameAbbr
            methodType
            isImmediatable
            isPoint
          }
          amount
          transactionId1
          isPaid
          editableType
          paymentSets {
            processCode
            statusCode
            isCancellable
          }
        }
        isPaid
        orderTotalPrice {
          net
          gross
        }
        currency
        lastUpdatedAt
      }
      point
      pointExpires
      limitedPoint
      limitedPointExpires
      rank {
        code
        name
        pointCoef
      }
    }
  }
`

/**
 * ポイント履歴
 */
export const GRAPH_QL_QUERY_POINT_LIST =
`
  query {
    points( ? ) {
      edges {
        node {
          point
          remains
          isLimited
          expires
          pointType
          reasonCode
          note
          memo
          createdAt
          attributes {
            attrId
            attrValue
          }
        }
      }
      totalCount
    }
  }
`

/**
 * 顧客ランク一覧
 */
export const GRAPH_QL_QUERY_RANK_LIST =
`
  query {
    customerRanks {
      code
      name
      customerGroup {
        code
        name
      }
    }
  }
`
